import React from "react";
import Link from "gatsby-link";
import addToMailchimp from 'gatsby-plugin-mailchimp'
import CookiesLink from '../Linking/cookiesLink'

class SignUpStatic extends React.Component {
  constructor() {
    super()
    this.state = {
      email: ``,
      name: ``,
      /*consent: ' '*/
    }
  }

  // Update state each time user edits their email address
  _handleEmailChange = e => {
    this.setState({ email: e.target.value })
  }
  
  _handleNameChange = e => {
    this.setState({ name: e.target.value })
  }

  /*
  _handleConsentChange = e => {
    this.setState(prevState => ({
      consent: prevState.consent == 'He leído y acepto la política de privacidad'?'':'He leído y acepto la política de privacidad'
    }))
  }
  */


  // Post to MC server & handle its response
  _postEmailToMailchimp = (email, attributes) => {
    addToMailchimp(email, attributes)
    .then(result => {

      // Mailchimp always returns a 200 response
      // So we check the result for MC errors & failures
      if (result.result !== `success`) {
        this.setState({
          status: `error`,
          msg: result.msg,
        })
      } else {
        // Email address succesfully subcribed to Mailchimp
        this.setState({
          status: `success`,
          msg: result.msg,
        })
      }
    })
    .catch(err => {
      // Network failures, timeouts, etc
      this.setState({
        status: `error`,
        msg: err,
      })
    })
  }

  _handleFormSubmit = e => {
    e.preventDefault()
    e.stopPropagation()

    this.setState({
        status: `sending`,
        msg: null,
      },
      // setState callback (subscribe email to MC)
      this._postEmailToMailchimp(this.state.email, {
        PATH: document.location.pathname,
        FIRST_NAME: this.state.name,
        'group[15725][1]':this.state.consent
      })
    )
  }

  render() {
    return (
      <div className="sign_up">
        {this.state.status === `success` ? (
          <div>¡Gracias! Recibirás el email de confirmación en unos instantes. Si no has recibido el email puede que haya sido enviado a la carpeta de spam o a la papelera. <br/><br/> Una vez confirmes tu suscripción podrás actualizar tus preferencias en cualquier momento desde los emails.</div>
        ) : (
          <div>
            <p>{this.props.message}</p>
            <form
              id="email-capture"
              method="post"
              noValidate
            >
              <div>
               <div className="form-control">
               <label>Email:</label>
                <input
                  type="email"
                  name="EMAIL"
                  placeholder="ejemplo@email.com"
                  onChange={this._handleEmailChange}
                />
               </div>
               <div className="form-control">
               <label>Nombre:</label>
                <input
                  type="text"
                  name="FIRST_NAME"
                  placeholder="Nombre"
                  onChange={this._handleNameChange}
                />
                </div>
                {/*
                       <div className="form-control full">

                <input type="checkbox" 
                required
                value="1" 
                name="group[15725][1]" 
                id="mce-group[15725]-15725-0"
                onChange={this._handleConsentChange}
                />
                <label for="mce-group[15725]-15725-0">He leído y acepto la  <CookiesLink/> </label>
              </div>
                */}
         
               
                <button
                  type="submit"
                  onClick={this._handleFormSubmit}
                >
                  Suscribirme
                </button>
                {this.state.status === `error` && (
                  <div
                    dangerouslySetInnerHTML={{ __html: this.state.msg }}
                    
                  />
                )}
              </div>
            </form>
          </div>
        )}
      </div>
    )
  }
}

export default SignUpStatic
























/*
const SignUpStatic = ()=> (
    <div>
<form>
    <h4>Recibe la newsletter</h4>
    <label for="email">Email:</label>
    <input type="email" id="email"/>
</form>
</div>
)*/

































/*
export default class SignUpStatic extends React.Component {
  // Since `addToMailchimp` returns a promise, you
  // can handle the response in two different ways:

  // Note that you need to send an email & optionally, listFields
  // these values can be pulled from React state, form fields,
  // or wherever.  (Personally, I recommend storing in state).

  // 1. via `.then`
  _handleSubmit = e => {
    e.preventDefault;
    addToMailchimp(email, {FNAME: 'Ben',  LNAME: 'Bordeaux'})
    .then(data => {
      // I recommend setting data to React state
      // but you can do whatever you want
      console.log(data)
    })
    .catch(() => {
      // unnecessary because Mailchimp only ever
      // returns a 200 status code
      // see below for how to handle errors
    })
  }

// 2. via `async/await`
  _handleSubmit = async (e) => {
    e.preventDefault;
    const result = await addToMailchimp(email, listFields)
    // I recommend setting `result` to React state
    // but you can do whatever you want
  }

  render () {
    return (
      <form onSubmit={this._handleSubmit(email, {listFields})}>
        Example
      </form>
    )
  }
}
*/
//export default SignUpStatic


// WEBPACK FOOTER //
// ./src/components/Forms/signUpStatic.js